import React from 'react';
import CommonScatterBubblePlot from './CommonScatterBubblePlot';

function ScatterBubblePlot(props) {
  return <CommonScatterBubblePlot {...props} />;
}
export default ScatterBubblePlot;
